import { useContext, useEffect, useState } from "react";
import Header from "../Header";
import { useParams } from "react-router-dom";
import config from "../../config";
import { AuthContext } from "../../contexts/AuthContext";
import { CountryContext } from "../../pages/CountryWrapper";
import CountryTranslations from "./CountryTranslations";
import CountryMap from "./CountryMap";
import CountryMeta from "./CountryMeta";
import Error from "../Error";
import { generateId } from "../../util/Random";
import { wrapFetch } from "../../util/Hmac";
import CountryDetails from "./CountryDetails";
import CountryLists from "./CountryLists";
import CountryMaps from "./CountryMaps";

function CountryDetail() {
    const { id } = useParams();
    const [country, setCountry] = useContext(CountryContext);
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const authValue = useContext(AuthContext);

    useEffect(() => {
        document.title = `GeoCMS\u00ae | ${country.name_default}`;
    }, [country]);

    useEffect(() => {
        async function getData() {
            try {
                const result = await wrapFetch(`${config.geoid_url_v3}/v3/cms/country/${id}?cb=${generateId(8)}`);

                // Sort translations by language code
                result.translations.sort((a, b) => {
                    if (a.language_code < b.language_code) {
                        return -1;
                    } else if (a.language_code > b.language_code) {
                        return 1;
                    }

                    return 0;
                });

                setCountry(result);
            } catch (error) {
                setError(error);
            } finally {
                setIsLoaded(true);
            }
        }

        if (authValue && authValue.user) {
            getData();
        }
    }, [id, setCountry, authValue]);

    if (error) {
        return (
            <div className="Country">
                <Header heading="Country" />

                <Error error={error} />
            </div>
        )
    } else if (!isLoaded) {
        return (
            <div className="Country">
                <Header heading="Country" loading={true} />

                <div className="flex flex-col max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <div className="bg-gray-200 w-full animate-pulse h-64 rounded-lg mb-4"></div>
                </div>
            </div>
        )
    } else if (country) {
        return (
            <div className="Country">
                <Header heading={country.name_default} />

                <div className="flex flex-col max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <CountryMeta />

                    <CountryDetails />

                    <CountryTranslations />

                    <CountryLists />

                    <CountryMaps />

                    <CountryMap />
                </div>
            </div>
        )
    }
}

export default CountryDetail;